import "./Btn_rect.css";

const Btn_rect = ({ label = "Contact", onClick, base_color="#00697E", text_color='#fff',border_color,hover_bg = "#fff", hover_text = "#000",hover_border_color="#000",border_radius="10px"}) => {
  return (
    <button className="contact-btn" style={{ 
      "--btn_bg":base_color,
      "--btn_text":text_color,
      "--btn_border":border_color,
      "--hover_btn_bg":hover_bg,
      "--hover_btn_text":hover_text,
      "--hover_btn_border":hover_border_color,
      "--border_radius":border_radius,
    }} onClick={onClick}>
      {label}
    </button>
  );
};

export default Btn_rect;
